<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col md="12">
                <b-card>
                    <div slot="header">
                        <b-row>
                            <b-col md="6" class="text-start">
                                <strong>Pickup Done</strong>
                            </b-col>
                        </b-row>
                    </div>

                    <div id="listloader" v-if="loader">
                        <div class="listloader"></div>
                    </div>
                    
                    <div>
                        <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                            <b-row>
                                <b-col md="6">
                                    <b-form-group>
                                        <b-row>
                                            <b-col sm="4">
                                                <label for="Load Id"><b>Load Id/Parent AWB</b></label>&nbsp;<span style="color: red;">*</span><b>&nbsp;&nbsp;:</b>
                                            </b-col>
                                            <b-col sm="8">
                                                <vue-tags-input
                                                    v-model="customer.shippingid"
                                                    :tags="tags"
                                                    @tags-changed="(newTags) => (tags = newTags)"
                                                    :avoidAddingDuplicates="avoidAddingDuplicates"
                                                    :placeholder="placeholder"
                                                    ref="taginput"
                                                    v-bind:separators="[',', ';']"
                                                />
                                                <span class="badge badge-success1">&nbsp;</span>&nbsp;
                                                <label :label-cols="4">Unique Load Id</label><br />
                                                <span class="badge badge-success2">&nbsp;</span
                                                >&nbsp;&nbsp;<label :label-cols="4">Repeat/Duplicate Load Id
                                                </label>
                    
                                                <span v-show="errors.has('form-1.shipmentid')"
                                                class="help text-danger">{{ errors.first("form-1.shipmentid") }}</span>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>
                                </b-col>
                                <b-col md="3">
                                    <b-button :disabled="isReadOnly || tags.length==0" class="mr-4"
                                      type="submit" size="md" variant="primary">Pickup Done</b-button>
                                    <b-button @click="clear()" size="md" variant="danger">Clear</b-button>
                                </b-col>
                            </b-row>
                        </b-form>
                    </div>
                    <div slot="footer">
                        <b-row>
                            <b-col md="12" v-if="ValidAWBshipment">
                                <span>
                                    <h6>
                                        Valid Shipmemnts :
                                        <strong v-for="valid in ValidAWBshipment"> {{ valid }}</strong>
                                    </h6>
                                </span>
                            </b-col>
                            <b-col md="12" v-if="invalidshipppingid">
                                <span>
                                    <h6>
                                        Invalid Shipmemnts :
                                        <strong v-for="invalid in invalidshipppingid"> {{ invalid }}</strong>
                                    </h6>
                                </span>
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
import VueTagsInput from "@johmun/vue-tags-input";
export default {
    components: {
        VueTagsInput,
    },
    data() {
        return {
            loader:false,
            customer :{},
            tags: [],
            avoidAddingDuplicates: false,
            placeholder: "Add Load Id/Parent AWB",
            parentawbtag:[],
            ValidAWBshipment:'',
            invalidshipppingid:'',
            accessBody:[],
            isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.accessBody = userInfo.body;
        this.ischeckbodyvalidation();
    },
    

    methods:{
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Pick Done' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Pick Done' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                if (k.title=='Mark Pickup Done' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
               
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        
        validateForm(scope) {
            this.$validator.validateAll(scope).then((result) => {
                if (result) {
                    this.reallocate()
                }
            });
        },

        reallocate() {
            this.loader = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            
            var load_id = [];
            this.parentawbtag = [];

            for (let i = 0; i < this.tags.length; i++) {
                load_id = this.tags[i].text;
                this.parentawbtag.push(load_id);
            }

     
            const Obj = {
                parentawb: this.parentawbtag,
                lastmodifiedby: `${userInfo.sysemailid}`
            };
            console.log("Obj", Obj);
            // return false
            this.$http .post(`${CONSTANTS.MIGRATION_API_URL}/markPickdoneManually`, Obj)
            .then((result) => {
                this.loader = false;
                if (result.body.returnmsg === "Successful") {
                    this.ValidAWBshipment = result.body.ValidAWB;
                    this.invalidshipppingid = result.body.InValidAWB;
                    this.$fire({
                    text: result.body.returnvalue,
                    type: "success",
                    timer: 30000,
                    });
                    this.tags = [];
                    this.parentawbtag = [];
                    
                } else {
                    this.ValidAWBshipment = result.body.ValidAWB;
                    this.invalidshipppingid = result.body.InValidAWB;
                    this.tags = [];
                    this.$fire({
                    text: result.body.returnvalue,
                    type: "error",
                    timer: 30000,
                    });
                }
            });
        },
        clear: function() {
            this.customer = {};
            this.tags = [];
            this.ValidAWBshipment = '';
            this.invalidshipppingid = '';
        }
    },
}
</script>

<style>
.ti-input{
    width: 330px !important;
}
</style>